import React from "react"
import { useForm } from "react-hook-form"
import { zodResolver } from "@hookform/resolvers/zod"
import { Space, Button, message } from "@mimber/ui-web"
import { Form, InputField } from "@mimber/forms"
import { useSuspendMember } from "@mimber/client/mimber-organization"
import {
  suspendMemberFormSchema,
  type SuspendMemberFormData,
} from "./SuspendMemberForm.schema"
import type { SuspendMemberFormProps } from "./SuspendMemberForm.types"

export const SuspendMemberForm: React.FunctionComponent<
  SuspendMemberFormProps
> = ({ memberUuid, onSuccess, onCancel }) => {
  const form = useForm<SuspendMemberFormData>({
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    resolver: zodResolver(suspendMemberFormSchema) as any,
    mode: "onBlur",
    defaultValues: {
      reason: "",
    },
  })

  const {
  } = form

  const suspendMutation = useSuspendMember(memberUuid, {
    onSuccess: () => {
      message.success("Member suspended successfully")
      onSuccess?.()
    },
    onError: (error) => {
      message.error(`Failed to suspend member: ${error.message}`)
    },
  })

  const onSubmit = (data: SuspendMemberFormData) => {
    suspendMutation.mutate(data)
  }

  return (
    <Form
      form={form}
      onSubmit={onSubmit}
      disabled={suspendMutation.isPending}
      layout="vertical"
    >
      <InputField
        name="reason"
        label="Reason for Suspension"
        multiline
        placeholder="Describe why this member is being suspended"
        rows={4}
        required
      />

      <Space
        style={{ width: "100%", justifyContent: "flex-end", marginTop: 8 }}
      >
        <Button onClick={onCancel} disabled={suspendMutation.isPending}>
          Cancel
        </Button>
        <Button
          type="primary"
          danger
          htmlType="submit"
          loading={suspendMutation.isPending}

        >
          Suspend Member
        </Button>
      </Space>
    </Form>
  )
}
